import React, { useEffect, useState } from "react";
import "./usernameLogin.css";
// import { Input } from "antd";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { addTempUser } from "../../store/loginActions";
import { useDispatch } from "react-redux";
import { bottomBarActions } from "../../store/bottomBarSlice";
import BetaWarningIcon from "../../assets/ReactSvg/BetaWarningIcon";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
}));

const UsernameLogin = () => {
  const usernameLocal = localStorage.getItem("username");
  const classes = useStyles();
  const dispatch = useDispatch();
  const [username, setUsername] = useState(usernameLocal || "");
  const [isSavePressed, setIsSavePressed] = useState(false);

  const handleSave = () => {
    const tempUser = {
      mpUserId: localStorage.getItem("mpUserId"),
      username,
    };
    localStorage.setItem("username", username);
    dispatch(addTempUser(tempUser));
    setIsSavePressed(true);
  };

  const onHomeClick = () => {
    dispatch(bottomBarActions.loadTab({ tabName: "chef" }));
  };

  if (usernameLocal || isSavePressed) {
    return (
      <div className="browseDishMain">
        <div style={{ minHeight: "100dvh" }} className="empty-cart-wrapper">
            <BetaWarningIcon />

          <p className="empty-cart-description Satoshi">
            This app is currently in beta mode. Items to the cart will be
            available once we go live.
          </p>
          <button onClick={onHomeClick} className="empty-cart-button Satoshi">
            Back to home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="usernameLoginWrapper">
      <div className="userNameHeaderTitle Satoshi">
        Hey there, Let’s get started with username
      </div>
      <div className="userNameHeaderlabel Satoshi">
        We're currently setting up your username. We'll collect your mobile
        number when you place your first order with us.
      </div>
      <div className="userNameTextBoxWrapper">
        <form className={classes.root} noValidate autoComplete="off">
          <TextField
            className="userNameTextFieldInput"
            id="standard-basic"
            label="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </form>
      </div>
      <div className="userNameValidationWrapper">
        <CheckCircleIcon style={{ color: "#00BB6D" }} />
        <div className="userNameValidationText Satoshi">
          This username is available.
        </div>
      </div>
      <button
        className={`payBottomModalContainerConfirmBtn userNameSaveBtn Satoshi`}
        onClick={handleSave}
        disabled={usernameLocal}
      >
        <div className="payBottomModalContainerConfirmBtnContent">Save</div>
      </button>
    </div>
  );
};

export default UsernameLogin;
